import {IS_WEB} from '#/env'

export type NetworkProfile = 'fast' | 'medium' | 'poor' | 'save-data'

export type NetworkHints = {
  downlink: number | null
  effectiveType: string | null
  saveData: boolean
}

const FAST_DOWNLINK_MBPS = 4

export function networkProfileFromHints(h: NetworkHints): NetworkProfile {
  if (h.saveData) return 'save-data'
  if (h.downlink != null && Number.isFinite(h.downlink)) {
    if (h.downlink >= FAST_DOWNLINK_MBPS) return 'fast'
    if (h.downlink >= 1.5) return 'medium'
    return 'poor'
  }
  switch (h.effectiveType) {
    case '4g':
      return 'fast'
    case '3g':
      return 'medium'
    case '2g':
    case 'slow-2g':
      return 'poor'
    default:
      return 'fast'
  }
}

export function getNetworkHints(): NetworkHints {
  if (IS_WEB) {
    const conn = (navigator as unknown as Record<string, unknown>)
      .connection as
      | {downlink?: number; effectiveType?: string; saveData?: boolean}
      | undefined
    return {
      downlink: conn?.downlink ?? null,
      effectiveType: conn?.effectiveType ?? null,
      saveData: conn?.saveData ?? false,
    }
  }
  // Native: Network Information API not available without NetInfo package.
  // Return fast defaults — the HLS client manages its own ABR.
  return {downlink: null, effectiveType: null, saveData: false}
}

export function getNetworkProfile(): NetworkProfile {
  return networkProfileFromHints(getNetworkHints())
}
